import { ApplicationUser } from '@/types/application-user';

export const isUserTechnician = (
  user: Pick<ApplicationUser, 'role'>,
): boolean => user.role.id === 3;
